import {CSSProperties, ReactNode} from 'react';
import Transition, {
  TransitionStatus,
  ExitHandler,
} from 'react-transition-group/Transition';
import {DEFAULT_ANIMATION_DURATION} from '../scss/util/variable';
import {IEffectStyle, EffectTypeCamelMap} from '../type';

interface IProps {
  show: boolean;
  duration?: number;
  effectStyleList: IEffectStyle[];
  children: ReactNode;
  onExited?: ExitHandler<HTMLElement>;
}

export default function EffectContainer({
  show,
  duration = DEFAULT_ANIMATION_DURATION,
  effectStyleList,
  children,
  onExited,
}: IProps) {
  return (
    <Transition in={show} timeout={duration} appear onExited={onExited}>
      {state => {
        if (state === 'exited') {
          return null;
        }
        return (
          <div
            style={getEffectStyle({
              state,
              effectStyleList,
              duration,
            })}
          >
            {children}
          </div>
        );
      }}
    </Transition>
  );
}

function getEffectStyle({
  state,
  effectStyleList,
  duration,
}: {
  state: TransitionStatus;
  effectStyleList: IEffectStyle[];
  duration: number;
}) {
  const effectStyle: CSSProperties = {};
  effectStyleList.forEach(item => {
    const {type, defaultValue, value} = item;
    // @ts-ignore 타입 수정하자
    effectStyle[EffectTypeCamelMap[type]] =
      value[state] !== undefined ? value[state] : defaultValue;
  });
  effectStyle.transition = effectStyleList
    .map(item => {
      return `${item.type} ${duration}ms ease-in-out`;
    })
    .join(', ');
  return effectStyle;
}
